import { DropdownColumnFilter } from "../components/tmt/DropdownColumnFilter";
import {
  createTextColumnFilter,
  createTextColumnEditor,
} from "../components/tmt/common/createTextColumn";
import {
  createNumberColumnFilter,
  createNumberColumnEditor,
} from "../components/tmt/common/createNumberColumn";
import {
  createSelectColumnFilter,
  createSelectColumnEditor,
} from "../components/tmt/common/createSelectColumn";
import {
  createLiveLoadAutocompleteColumnFilter,
  createLiveLoadAutocompleteColumnEditor,
} from "../components/tmt/common/createLiveLoadAutocompleteColumn";
import {
  createDateColumnFilter,
  createDateColumnEditor,
} from "../components/tmt/common/createDateColumn";
import {
  AWARD_BACKUP_TYPE,
  ACTIVE_FLAG,
  DOWNLOADED_FLAG,
  STATUS,
  CATEGORY,
  BUCKET_TYPE,
  TABLE_NAME as tableName,
  REGION,
  CARRIER_MANAGER,
  ORDER_TYPE,
  PRE_AWARD,
} from "../helpers"; //, STATUS,BUCKET_TYPE,

import "./columns.sass";

//------------------DRMT---------------------------//

export const COLUMN_CONFIGS = {
  carrierScac: {
    filterComponent: createLiveLoadAutocompleteColumnFilter({
      key: "carriers",
      getLabel: (opt) => opt?.scacCode || "",
    }),
    editComponent: createLiveLoadAutocompleteColumnEditor({
      key: "carriers",
      getLabel: (opt) => opt?.scacCode || "",
    }),
    type: "autocomplete",
  },

  serviceScac: {
    filterComponent: createLiveLoadAutocompleteColumnFilter({
      key: "services",
      getLabel: (opt) => opt?.serviceCode || "",
    }),
    editComponent: createLiveLoadAutocompleteColumnEditor({
      key: "services",
      getLabel: (opt) => opt?.serviceCode || "",
    }),
    type: "autocomplete",
  },

  tariffNumber: {
    filterComponent: createTextColumnFilter(),
    editComponent: createLiveLoadAutocompleteColumnEditor({
      key: "tariffIds",
      getLabel: (opt) => opt?.tariffId || "",
    }),
    type: "autocomplete",
  },

  tariffId: {
    filterComponent: createTextColumnFilter(),
    editComponent: createLiveLoadAutocompleteColumnEditor({
      key: "tariffIds",
      getLabel: (opt) => opt?.tariffCode || "",
    }),
    type: "autocomplete",
  },

  orgHub: {
    filterComponent: createTextColumnFilter(),
    editComponent: createTextColumnEditor(),
    type: "default",
  },

  originZone: {
    filterComponent: createLiveLoadAutocompleteColumnFilter({
      key: "zones",
      getLabel: (opt) => opt?.zoneCode || "",
    }),
    editComponent: createLiveLoadAutocompleteColumnEditor({
      key: "zones",
      getLabel: (opt) => opt?.zoneCode || "",
    }),
    type: "autocomplete",
  },

  originZoneDesc: {
    filterComponent: createLiveLoadAutocompleteColumnFilter({
      key: "zoneLongDesc",
      getLabel: (opt) => opt?.zoneDesc || "",
    }),
    editComponent: createLiveLoadAutocompleteColumnEditor({
      key: "zoneLongDesc",
      getLabel: (opt) => opt?.zoneDesc || "",
    }),
    type: "autocomplete",
  },

  originZoneShortDesc: {
    filterComponent: createLiveLoadAutocompleteColumnFilter({
      key: "zoneShortDesc",
      getLabel: (opt) => opt?.zoneShortDesc || "",
    }),
    editComponent: createLiveLoadAutocompleteColumnEditor({
      key: "zoneShortDesc",
      getLabel: (opt) => opt?.zoneShortDesc || "",
    }),
    type: "autocomplete",
  },

  originCity: {
    filterComponent: createTextColumnFilter(),
    editComponent: createTextColumnEditor(),
    type: "default",
  },

  originState: {
    filterComponent: createTextColumnFilter(),
    editComponent: createTextColumnEditor(),
    type: "default",
  },

  originCountry: {
    filterComponent: createLiveLoadAutocompleteColumnFilter({
      key: "countries",
      getLabel: (opt) => opt?.countryCode || "",
    }),
    editComponent: createLiveLoadAutocompleteColumnEditor({
      key: "countries",
      getLabel: (opt) => opt?.countryCode || "",
    }),
    type: "autocomplete",
  },

  destHub: {
    filterComponent: createTextColumnFilter(),
    editComponent: createTextColumnEditor(),
    type: "default",
  },

  destinationZone: {
    filterComponent: createLiveLoadAutocompleteColumnFilter({
      key: "zones",
      getLabel: (opt) => opt?.zoneCode || "",
    }),
    editComponent: createLiveLoadAutocompleteColumnEditor({
      key: "zones",
      getLabel: (opt) => opt?.zoneCode || "",
    }),
    type: "autocomplete",
  },

  destinationZoneDesc: {
    filterComponent: createLiveLoadAutocompleteColumnFilter({
      key: "zoneLongDesc",
      getLabel: (opt) => opt?.zoneDesc || "",
    }),
    editComponent: createLiveLoadAutocompleteColumnEditor({
      key: "zoneLongDesc",
      getLabel: (opt) => opt?.zoneDesc || "",
    }),
    type: "autocomplete",
  },

  destinationZoneShortDesc: {
    filterComponent: createLiveLoadAutocompleteColumnFilter({
      key: "zoneShortDesc",
      getLabel: (opt) => opt?.zoneShortDesc || "",
    }),
    editComponent: createLiveLoadAutocompleteColumnEditor({
      key: "zoneShortDesc",
      getLabel: (opt) => opt?.zoneShortDesc || "",
    }),
    type: "autocomplete",
  },

  destinationCity: {
    filterComponent: createTextColumnFilter(),
    editComponent: createTextColumnEditor(),
    type: "default",
  },

  destinationState: {
    filterComponent: createTextColumnFilter(),
    editComponent: createTextColumnEditor(),
    type: "default",
  },

  destinationCountry: {
    filterComponent: createLiveLoadAutocompleteColumnFilter({
      key: "countries",
      getLabel: (opt) => opt?.countryCode || "",
    }),
    editComponent: createLiveLoadAutocompleteColumnEditor({
      key: "countries",
      getLabel: (opt) => opt?.countryCode || "",
    }),
    type: "autocomplete",
  },

  region: {
    filterComponent: createSelectColumnFilter(REGION),
    editComponent: createSelectColumnEditor(REGION),
    type: "select",
  },

  carrierManager: {
    filterComponent: createSelectColumnFilter(CARRIER_MANAGER),
    editComponent: createSelectColumnEditor(CARRIER_MANAGER),
    type: "select",
  },

  miles: {
    filterComponent: createNumberColumnFilter(), //createNumberColumnFilter()
    editComponent: createNumberColumnEditor(),
    type: "default",
  },

  orderType: {
    filterComponent: createSelectColumnFilter(ORDER_TYPE),
    editComponent: createSelectColumnEditor(ORDER_TYPE),
    type: "select",
  },

  laneServiceType: {
    filterComponent: createSelectColumnFilter(ORDER_TYPE),
    editComponent: createSelectColumnEditor(ORDER_TYPE),
    type: "select",
  },

  primaryCustomers: {
    filterComponent: createTextColumnFilter(),
    editComponent: createTextColumnEditor(),
    type: "default",
  },

  preAwarded: {
    filterComponent: createSelectColumnFilter(PRE_AWARD),
    editComponent: createSelectColumnEditor(PRE_AWARD),
    type: "select",
  },

  equipmentType: {
    filterComponent: createLiveLoadAutocompleteColumnFilter({
      key: "equipments",
      getLabel: (opt) => opt?.equipmentTypeCode || "",
    }),
    editComponent: createLiveLoadAutocompleteColumnEditor({
      key: "tariffEquipmentMapping", // equipments, tariffEquipmentMapping
      getLabel: (opt) => opt?.equipmentType || "",
    }),
    type: "autocomplete",
  },

  laneDescription: {
    filterComponent: createTextColumnFilter(),
    editComponent: createTextColumnEditor(),
    type: "default",
  },

  lineHaulChargeType: {
    filterComponent: createLiveLoadAutocompleteColumnFilter({
      key: "charges",
      getLabel: (opt) => opt?.chargeCode || "",
    }),
    editComponent: createLiveLoadAutocompleteColumnEditor({
      key: "charges",
      getLabel: (opt) => opt?.chargeCode || "",
    }),
    type: "autocomplete",
  },

  btfRate: {
    filterComponent: createNumberColumnFilter(), //createNumberColumnFilter()
    editComponent: createNumberColumnEditor(),
    type: "number",
  },

  lineHaulRate: {
    filterComponent: createNumberColumnFilter(), //createNumberColumnFilter()
    editComponent: createNumberColumnEditor(),
    type: "number",
  },

  rate: {
    filterComponent: createNumberColumnFilter(), //createNumberColumnFilter()
    editComponent: createNumberColumnEditor(),
    type: "number",
  },

  awardBackup: {
    filterComponent: createSelectColumnFilter(AWARD_BACKUP_TYPE),
    editComponent: createSelectColumnEditor(AWARD_BACKUP_TYPE),
    type: "select",
  },

  effectiveDate: {
    filterComponent: createDateColumnFilter("MM/DD/YYYY"),
    editComponent: createDateColumnEditor("MM/DD/YYYY"),
    type: "date",
  },

  expirationDate: {
    filterComponent: createDateColumnFilter("MM/DD/YYYY"),
    editComponent: createDateColumnEditor("MM/DD/YYYY"),
    type: "date",
  },

  bucketType: {
    filterComponent: createSelectColumnFilter(BUCKET_TYPE),
    editComponent: createSelectColumnEditor(BUCKET_TYPE),
    type: "select",
  },
  qtyBucketType: {
    filterComponent: createSelectColumnFilter(BUCKET_TYPE),
    editComponent: createSelectColumnEditor(BUCKET_TYPE),
    type: "select",
  },
  pctBucketType: {
    filterComponent: createSelectColumnFilter(BUCKET_TYPE),
    editComponent: createSelectColumnEditor(BUCKET_TYPE),
    type: "select",
  },

  qtyActiveFlag: {
    filterComponent: createSelectColumnFilter(ACTIVE_FLAG),
    editComponent: createSelectColumnEditor(ACTIVE_FLAG),
    type: "select",
  },

  qtyStartDate: {
    filterComponent: createDateColumnFilter("MM/DD/YYYY"),
    editComponent: createDateColumnEditor("DD-MM-YYYY"),
    type: "date",
  },

  qtyEndDate: {
    filterComponent: createDateColumnFilter("MM/DD/YYYY"),
    editComponent: createDateColumnEditor("DD-MM-YYYY"),
    type: "date",
  },

  minShipmentsAllocated: {
    filterComponent: createNumberColumnFilter(),
    editComponent: createNumberColumnEditor(),
    type: "number",
  },

  maxShipmentsAllocated: {
    filterComponent: createNumberColumnFilter(),
    editComponent: createNumberColumnEditor(),
    type: "number",
  },

  percentageActiveFlag: {
    filterComponent: createSelectColumnFilter(ACTIVE_FLAG),
    editComponent: createSelectColumnEditor(ACTIVE_FLAG),
    type: "select",
  },

  pctStartDate: {
    filterComponent: createDateColumnFilter("MM/DD/YYYY"),
    editComponent: createDateColumnEditor("DD-MM-YYYY"),
    type: "date",
  },

  pctEndDate: {
    filterComponent: createDateColumnFilter("MM/DD/YYYY"),
    editComponent: createDateColumnEditor("DD-MM-YYYY"),
    type: "date",
  },

  minCarrierAllocationPercentage: {
    filterComponent: createNumberColumnFilter(),
    editComponent: createNumberColumnEditor(),
    type: "number",
  },

  maxCarrierAllocationPercentage: {
    filterComponent: createNumberColumnFilter(),
    editComponent: createNumberColumnEditor(),
    type: "number",
  },

  pctAward: {
    filterComponent: createNumberColumnFilter(),
    editComponent: createNumberColumnEditor(),
    type: "number",
  },

  modeOfTransport: {
    filterComponent: createLiveLoadAutocompleteColumnFilter({
      key: "transports",
      getLabel: (opt) => opt?.modeOfTransport || "",
    }),
    editComponent: createLiveLoadAutocompleteColumnEditor({
      key: "transports",
      getLabel: (opt) => opt?.modeOfTransport || "",
    }),
    type: "autocomplete",
  },

  status: {
    filterComponent: createSelectColumnFilter(STATUS),
    editComponent: createSelectColumnEditor(STATUS),
    type: "select",
  },

  bidFileName: {
    filterComponent: createTextColumnFilter(),
    editComponent: createTextColumnEditor(),
    type: "default",
  },

  changeComment: {
    filterComponent: createTextColumnFilter(),
    editComponent: createTextColumnEditor(),
    type: "default",
  },

  coupaFileRecordErrors: {
    filterComponent: createTextColumnFilter(),
    editComponent: null,
    type: "default",
  },

  defaultError: {
    filterComponent: createTextColumnFilter(),
    editComponent: null,
    type: "default",
  },

  userId : {
    filterComponent: createTextColumnFilter(),
    editComponent: null,
    type: "default",
  },

  createdDate: {
   filterComponent: createDateColumnFilter("MM/DD/YYYY"),
    editComponent: null,
    type: "date",
  },

  message: {
    filterComponent: null,
    editComponent: null,
    type: "default",
  },

  fileCategory: {
    filterComponent: createSelectColumnFilter(CATEGORY),
    editComponent: null,
    type: "select",
  },

  countOfDeletableRecords: {
    filterComponent: null,
    editComponent: null,
    type: "number",
  },

  countOfRateExpirationRecords: {
    filterComponent: null,
    editComponent: null,
    type: "number",
  },

  countOfProcessableRecords: {
    filterComponent: null,
    editComponent: null,
    type: "number",
  },

  fileNames: {
    filterComponent: createTextColumnFilter(),
    editComponent: createTextColumnEditor(),
    type: "default",
  },
  createdAt: {
    filterComponent: createDateColumnFilter("MM/DD/YYYY"),
    editComponent: null,
    type: "date",
  },
  uploadedDate: {
    filterComponent: createDateColumnFilter("MM/DD/YYYY"),
    editComponent: null,
    type: "date",
  },
  fileSize: {
    filterComponent: createNumberColumnFilter(),
    editComponent: null,
    type: "number", 
  },
  fileName: {
    filterComponent: createTextColumnFilter(),
    editComponent: null,
    type: "default",
  },
  isDownloaded: {
      filterComponent: createSelectColumnFilter(DOWNLOADED_FLAG),
      editComponent: null,
      type: "default",
  },
  systemRateId: {
    filterComponent: createTextColumnFilter(),
    editComponent: null,
    type: "default",

  }
};

export const COLUMN_EDITING_RULES = {
  carrierScac: { inline: { Bid: true, Daily: false }, newRecord: { inline: true, copy: true, blank: false },  },
  serviceScac: { inline: { Bid: true, Daily: false }, newRecord: { inline: true, copy: true, blank: false } },
  tariffNumber: { inline: { Bid: false, Daily: false }, newRecord: { inline: true, copy: true, blank: false } },
  tariffId: { inline: { Bid: false, Daily: false }, newRecord: { inline: true, copy: true, blank: false } },
  orgHub: { inline: { Bid: true, Daily: false }, newRecord: { inline: true, copy: true, blank: false } },
  originZone: { inline: { Bid: true, Daily: false }, newRecord: { inline: true, copy: true, blank: false } },
  originZoneDesc: { inline: { Bid: true, Daily: false }, newRecord: { inline: false, copy: false, blank: true } },
  originZoneShortDesc: { inline: { Bid: true, Daily: false }, newRecord: { inline: false, copy: false, blank: true } },
  originCity: { inline: { Bid: true, Daily: false }, newRecord: { inline: false, copy: false, blank: true } },
  originState: { inline: { Bid: true, Daily: false }, newRecord: { inline: false, copy: false, blank: true } },
  originCountry: { inline: { Bid: true, Daily: false }, newRecord: { inline: true, copy: true, blank: false } },
  destHub: { inline: { Bid: true, Daily: false }, newRecord: { inline: true, copy: true, blank: false } },
  destinationZone: { inline: { Bid: true, Daily: false }, newRecord: { inline: true, copy: true, blank: false } },
  destinationZoneDesc: { inline: { Bid: true, Daily: false }, newRecord: { inline: false, copy: false, blank: true } },
  destinationZoneShortDesc: { inline: { Bid: true, Daily: false }, newRecord: { inline: false, copy: false, blank: true } },
  destinationCity: { inline: { Bid: true, Daily: false }, newRecord: { inline: false, copy: false, blank: true } },
  destinationState: { inline: { Bid: true, Daily: false }, newRecord: { inline: false, copy: false, blank: true } },
  destinationCountry: { inline: { Bid: true, Daily: false }, newRecord: { inline: true, copy: true, blank: false } },
  region: { inline: { Bid: true, Daily: false }, newRecord: { inline: false, copy: false, blank: true } },
  carrierManager: { inline: { Bid: true, Daily: false }, newRecord: { inline: false, copy: false, blank: true } },
  miles: { inline: { Bid: true, Daily: false }, newRecord: { inline: false, copy: false, blank: true } },
  orderType: { inline: { Bid: true, Daily: false }, newRecord: { inline: false, copy: false, blank: true } },
  laneServiceType: { inline: { Bid: true, Daily: false }, newRecord: { inline: false, copy: false, blank: true } },
  primaryCustomers: { inline: { Bid: true, Daily: false }, newRecord: { inline: false, copy: false, blank: true } },
  preAwarded: { inline: { Bid: true, Daily: false }, newRecord: { inline: false, copy: false, blank: false } },
  equipmentType: { inline: { Bid: true, Daily: false }, newRecord: { inline: true, copy: false, blank: false } },
  laneDescription: { inline: { Bid: true, Daily: false }, newRecord: { inline: true, copy: true, blank: false } },
  lineHaulChargeType: { inline: { Bid: true, Daily: false },newRecord: { inline: true, copy: true, blank: false } },
  btfRate: { inline: { Bid: true, Daily: false }, newRecord: { inline: false, copy: false, blank: true } },
  lineHaulRate: { inline: { Bid: true, Daily: true }, newRecord: { inline: true, copy: false, blank: true } },
  rate: { inline: { Bid: true, Daily: true }, newRecord: { inline: true, copy: false, blank: true } },
  awardBackup: { inline: { Bid: true, Daily: false }, newRecord: { inline: true, copy: false, blank: true } },
  effectiveDate: { inline: { Bid: true, Daily: true }, newRecord: { inline: true, copy: true, blank: false } },
  expirationDate: { inline: { Bid: true, Daily: true }, newRecord: { inline: true, copy: true, blank: false } },
  bucketType: { inline: { Bid: true, Daily: true }, newRecord: { inline: true, copy: true, blank: false } },
  qtyBucketType: { inline: { Bid: true, Daily: true }, newRecord: { inline: true, copy: false, blank: true } },
  pctBucketType: { inline: { Bid: true, Daily: true }, newRecord: { inline: true, copy: false, blank: true } },
  qtyActiveFlag: { inline: { Bid: true, Daily: true }, newRecord: { inline: true, copy: false, blank: true } },
  qtyStartDate: { inline: { Bid: true, Daily: false }, newRecord: { inline: false, copy: false, blank: false } },
  qtyEndDate: { inline: { Bid: true, Daily: false }, newRecord: { inline: false, copy: false, blank: false } },
  minShipmentsAllocated: { inline: { Bid: true, Daily: true }, newRecord: { inline: true, copy: false, blank: true } },
  maxShipmentsAllocated: { inline: { Bid: true, Daily: true }, newRecord: { inline: true, copy: false, blank: true } },
  percentageActiveFlag: { inline: { Bid: true, Daily: true }, newRecord: { inline: true, copy: false, blank: true } },
  pctStartDate: { inline: { Bid: true, Daily: false }, newRecord: { inline: false, copy: false, blank: false } },
  pctEndDate: { inline: { Bid: true, Daily: false }, newRecord: { inline: false, copy: false, blank: false } },
  minCarrierAllocationPercentage: { inline: { Bid: true, Daily: true }, newRecord: { inline: true, copy: false, blank: true } },
  maxCarrierAllocationPercentage: { inline: { Bid: true, Daily: true }, newRecord: { inline: true, copy: false, blank: true } },
  pctAward: { inline: { Bid: true, Daily: true }, newRecord: { inline: true, copy: false, blank: true } },
  modeOfTransport: { inline: { Bid: true, Daily: false }, newRecord: { inline: true, copy: false, blank: true } },
  status: { inline: { Bid: false, Daily: false }, newRecord: { inline: false, copy: false, blank: false } },
  bidFileName: { inline: { Bid: true, Daily: false }, newRecord: { inline: false, copy: false, blank: false } },
  changeComment: { inline: { Bid: true, Daily: true }, newRecord: { inline: true, copy: false, blank: true } },
  coupaFileRecordErrors: { inline: { Bid: true, Daily: false }, newRecord: { inline: false, copy: false, blank: false } },
  defaultError: { inline: { Bid: false, Daily: false }, newRecord: { inline: false, copy: false, blank: false } },
  userId: { inline: { Bid: true, Daily: false }, newRecord: { inline: false, copy: false, blank: false } },
  createdDate: { inline: { Bid: true, Daily: false }, newRecord: { inline: false, copy: false, blank: false } },
  updatedDate: { inline: { Bid: true, Daily: false }, newRecord: { inline: false, copy: false, blank: false } },
  message: { inline: { Bid: true, Daily: false }, newRecord: { inline: false, copy: false, blank: false } },
  systemRateId: { inline: { Bid: true, Daily: false }, newRecord: { inline: false, copy: false, blank: false } },
};

export const getColumnEditPermission = (columnKey, tableType = "Bid") => {
  const normalized = tableType === "Daily" ? "Daily" : "Bid";
  const rule = COLUMN_EDITING_RULES[columnKey];
  return {
    allowInlineEdit: rule.inline?.[normalized],
    allowNewRecordEdit: rule.newRecord?.inline,
    duplicateCopy: rule.newRecord?.copy,
    duplicateBlank: rule.newRecord?.blank,
  };
};

Object.entries(COLUMN_EDITING_RULES).forEach(([key, rule]) => {
  if (!COLUMN_CONFIGS[key]) {
    return;
  }
  COLUMN_CONFIGS[key].allowInlineEdit = rule.inline;
  COLUMN_CONFIGS[key].allowNewRecordEdit = rule.newRecord;
});

// Column Definitions
export const DRM_COLUMN = [
  {
    Header: "carrierScac",
    fixed: "left",
    accessor: "carrierScac",
    width: 150,
    minWidth: 150,
    maxWidth: 150,
    color: true,
    Filter: DropdownColumnFilter,
    type: "edit",
  },
  {
    Header: "serviceScac",
    accessor: "serviceScac",
    width: 150,
    minWidth: 150,
    maxWidth: 150,
    color: true,
    Filter: DropdownColumnFilter,
    type: "edit",
  },
  {
    Header: "tariffNumber",
    accessor: "tariffNumber",
    // width: 150,
    // minWidth: 150,
    // maxWidth: 150,
    color: true,
    Filter: DropdownColumnFilter,
    type: "edit",
  },
  {
    Header: "tariffId",
    accessor: "tariffId",
    width: 150,
    minWidth: 150,
    maxWidth: 150,
    color: true,
    Filter: DropdownColumnFilter,
    type: "edit",
  },
  {
    Header: "orgHub",
    accessor: "orgHub",
    // width: 250,
    // minWidth: 250,
    // maxWidth: 250,
    //color: "green",
    color: true,
    Filter: DropdownColumnFilter,
    type: "edit",
  },
  {
    Header: "originZone",
    accessor: "originZone",
    width: 150,
    minWidth: 150,
    maxWidth: 150,
    //color: "green",
    color: true,
    Filter: DropdownColumnFilter,
    type: "edit",
  },
  {
    Header: "originZoneDesc",
    accessor: "originZoneDesc",
    width: 250,
    minWidth: 250,
    maxWidth: 250,
    Filter: DropdownColumnFilter,
    type: "edit",
  },
  {
    Header: "originZoneShortDesc",
    accessor: "originZoneShortDesc",
    width: 200,
    minWidth: 200,
    maxWidth: 200,
    Filter: DropdownColumnFilter,
    type: "edit",
  },
  {
    Header: "originCity",
    accessor: "originCity",
    // width: 200,
    // minWidth: 200,
    // maxWidth: 200,
    Filter: DropdownColumnFilter,
    type: "text",
  },
  {
    Header: "originState",
    accessor: "originState",
    // width: 200,
    // minWidth: 200,
    // maxWidth: 200,
    Filter: DropdownColumnFilter,
    type: "text",
  },
  {
    Header: "originCountry",
    accessor: "originCountry",
    color: true,
    // width: 150,
    // minWidth: 150,
    // maxWidth: 150,
    Filter: DropdownColumnFilter,
    type: "edit",
  },
  {
    Header: "destHub",
    accessor: "destHub",
    // width: 200,
    // minWidth: 200,
    // maxWidth: 200,
    // color: "green",
    color: true,
    Filter: DropdownColumnFilter,
    type: "edit",
  },
  {
    Header: "destinationZone",
    accessor: "destinationZone",
    width: 200,
    minWidth: 200,
    maxWidth: 200,
    // color: "green",
    color: true,
    Filter: DropdownColumnFilter,
    type: "edit",
  },
  {
    Header: "destinationZoneDesc",
    accessor: "destinationZoneDesc",
    width: 250,
    minWidth: 250,
    maxWidth: 250,
    Filter: DropdownColumnFilter,
    type: "edit",
  },
  {
    Header: "destinationZoneShortDesc",
    accessor: "destinationZoneShortDesc",
    width: 200,
    minWidth: 200,
    maxWidth: 200,
    Filter: DropdownColumnFilter,
    type: "edit",
  },
  {
    Header: "destinationCity",
    accessor: "destinationCity",
    // width: 200,
    // minWidth: 200,
    // maxWidth: 200,
    Filter: DropdownColumnFilter,
    type: "text",
  },
  {
    Header: "destinationState",
    accessor: "destinationState",
    // width: 200,
    // minWidth: 200,
    // maxWidth: 200,
    Filter: DropdownColumnFilter,
    type: "text",
  },
  {
    Header: "destinationCountry",
    accessor: "destinationCountry",
    color: true,
    // width: 150,
    // minWidth: 150,
    // maxWidth: 150,
    Filter: DropdownColumnFilter,
    type: "edit",
  },
  {
    Header: "region",
    accessor: "region",
    // width: 200,
    // minWidth: 200,
    // maxWidth: 200,
    Filter: DropdownColumnFilter,
    type: "text",
  },

  {
    Header: "carrierManager",
    accessor: "carrierManager",
    // width: 200,
    // minWidth: 200,
    // maxWidth: 200,
    Filter: DropdownColumnFilter,
    type: "text",
  },
  {
    Header: "miles",
    accessor: "miles",
    // width: 200,
    // minWidth: 200,
    // maxWidth: 200,
    Filter: DropdownColumnFilter,
    type: "text",
  },
  {
    Header: "orderType",
    accessor: "orderType",
    // width: 200,
    // minWidth: 200,
    // maxWidth: 200,
    Filter: DropdownColumnFilter,
    type: "text",
  },
  {
    Header: "laneServiceType",
    accessor: "laneServiceType",
    // width: 200,
    // minWidth: 200,
    // maxWidth: 200,
    Filter: DropdownColumnFilter,
    type: "text",
  },
  {
    Header: "primaryCustomers",
    accessor: "primaryCustomers",
    // width: 200,
    // minWidth: 200,
    // maxWidth: 200,
    Filter: DropdownColumnFilter,
    type: "text",
  },
  {
    Header: "preAwarded",
    accessor: "preAwarded",
    // width: 200,
    // minWidth: 200,
    // maxWidth: 200,
    Filter: DropdownColumnFilter,
    type: "text",
  },
  {
    Header: "equipmentType",
    accessor: "equipmentType",
    width: 150,
    minWidth: 150,
    maxWidth: 150,
    color: true,
    Filter: DropdownColumnFilter,
    type: "edit",
  },
  {
    Header: "laneDescription",
    accessor: "laneDescription",
    width: 250,
    minWidth: 250,
    maxWidth: 250,
    color: true,
    Filter: DropdownColumnFilter,
    type: "edit",
  },
  {
    Header: "lineHaulChargeType",
    accessor: "lineHaulChargeType",
    width: 150,
    minWidth: 150,
    maxWidth: 150,
    color: true,
    Filter: DropdownColumnFilter,
    type: "edit",
  },
  {
    Header: "btfRate",
    accessor: "btfRate",
    // width: 200,
    // minWidth: 200,
    // maxWidth: 200,
    Filter: DropdownColumnFilter,
    type: "text",
  },
  {
    Header: "rate",
    accessor: "rate",
    // width: 200,
    // minWidth: 200,
    // maxWidth: 200,
    color: true,
    Filter: DropdownColumnFilter,
    type: "edit",
  },
  {
    Header: "lineHaulRate",
    accessor: "lineHaulRate",
    // width: 200,
    // minWidth: 200,
    // maxWidth: 200,
    Filter: DropdownColumnFilter,
    type: "edit",
  },
  {
    Header: "awardBackup",
    accessor: "awardBackup",
    // width: 150,
    // minWidth: 150,
    // maxWidth: 150,
    Filter: DropdownColumnFilter,
    type: "edit",
  },
  {
    Header: "effectiveDate",
    accessor: "effectiveDate",
    // width: 200,
    // minWidth: 200,
    // maxWidth: 200,
    color: true,
    Filter: DropdownColumnFilter,
    type: "edit",
  },
  {
    Header: "expirationDate",
    accessor: "expirationDate",
    // width: 200,
    // minWidth: 200,
    // maxWidth: 200,
    color: true,
    Filter: DropdownColumnFilter,
    type: "edit",
  },
  {
    Header: "bucketType",
    accessor: "bucketType",
    // width: 150,
    // minWidth: 150,
    // maxWidth: 150,
    Filter: DropdownColumnFilter,
    type: "edit",
  },

  {
    Header: "qtyBucketType",
    accessor: "qtyBucketType",
    // width: 150,
    // minWidth: 150,
    // maxWidth: 150,
    Filter: DropdownColumnFilter,
    type: "edit",
  },
  {
    Header: "pctBucketType",
    accessor: "pctBucketType",
    // width: 150,
    // minWidth: 150,
    // maxWidth: 150,
    Filter: DropdownColumnFilter,
    type: "edit",
  },

  {
    Header: "qtyActiveFlag",
    accessor: "qtyActiveFlag",
    // width: 150,
    // minWidth: 150,
    // maxWidth: 150,
    Filter: DropdownColumnFilter,
    type: "edit",
  },
  {
    Header: "qtyStartDate",
    accessor: "qtyStartDate",
    // width: 200,
    // minWidth: 200,
    // maxWidth: 200,
    Filter: DropdownColumnFilter,
    type: "edit",
  },
  {
    Header: "qtyEndDate",
    accessor: "qtyEndDate",
    // width: 200,
    // minWidth: 200,
    // maxWidth: 200,
    Filter: DropdownColumnFilter,
    type: "edit",
  },
  {
    Header: "minShipmentsAllocated",
    accessor: "minShipmentsAllocated",
    // width: 150,
    // minWidth: 150,
    // maxWidth: 150,
    Filter: DropdownColumnFilter,
    type: "edit",
  },
  {
    Header: "maxShipmentsAllocated",
    accessor: "maxShipmentsAllocated",
    // width: 150,
    // minWidth: 150,
    // maxWidth: 150,
    Filter: DropdownColumnFilter,
    type: "edit",
  },
  {
    Header: "percentageActiveFlag",
    accessor: "percentageActiveFlag",
    // width: 150,
    // minWidth: 150,
    // maxWidth: 150,
    Filter: DropdownColumnFilter,
    type: "edit",
  },
  {
    Header: "pctStartDate",
    accessor: "pctStartDate",
    // width: 200,
    // minWidth: 200,
    // maxWidth: 200,
    Filter: DropdownColumnFilter,
    type: "edit",
  },
  {
    Header: "pctEndDate",
    accessor: "pctEndDate",
    // width: 200,
    // minWidth: 200,
    // maxWidth: 200,
    Filter: DropdownColumnFilter,
    type: "edit",
  },
  {
    Header: "minCarrierAllocationPercentage",
    accessor: "minCarrierAllocationPercentage",
    // width: 150,
    // minWidth: 150,
    // maxWidth: 150,
    Filter: DropdownColumnFilter,
    type: "edit",
  },
  {
    Header: "maxCarrierAllocationPercentage",
    accessor: "maxCarrierAllocationPercentage",
    // width: 150,
    // minWidth: 150,
    // maxWidth: 150,
    Filter: DropdownColumnFilter,
    type: "edit",
  },
  {
    Header: "pctAward",
    accessor: "pctAward",
    // width: 150,
    // minWidth: 150,
    // maxWidth: 150,
    Filter: DropdownColumnFilter,
    type: "edit",
  },
  {
    Header: "modeOfTransport",
    accessor: "modeOfTransport",
    width: 150,
    minWidth: 150,
    maxWidth: 150,
    color: true,
    Filter: DropdownColumnFilter,
    type: "edit",
  },
  {
    Header: "status", //only different
    accessor: "message",
    width: 220,
    minWidth: 220,
    maxWidth: 220,
    Filter: DropdownColumnFilter,
    type: "text",
  },
  {
    Header: "bidFileName",
    accessor: "bidFileName",
    // width: 250,
    // minWidth: 250,
    // maxWidth: 250,
    Filter: DropdownColumnFilter,
    type: "edit",
  },
  {
    Header: "changeComment",
    accessor: "changeComment",
    // width: 250,
    // minWidth: 250,
    // maxWidth: 250,
    //disableFilters: true, // <-- this disables the filter properly
    Filter: DropdownColumnFilter,
    type: "edit",
  },
  {
    Header: "message",
    accessor: "message",
    // width: 250,
    // minWidth: 250,
    // maxWidth: 250,
    type: "text",
    disableFilters: true, // <-- this disables the filter properly
    // type: "edit",
  },
  // {
  //   Header: "errors",
  //   accessor: "errors",
  //   width: 250,
  //   minWidth: 250,
  //   maxWidth: 250,
  //   type: "errors",
  //   // disableFilters: true, // <-- this disables the filter properly
  //    Filter: DropdownColumnFilter,
  // },
  {
    Header: "defaultError",
    accessor: "defaultError",
    // width: 250,
    // minWidth: 250,
    // maxWidth: 250,
    type: "errors",
    // disableFilters: true, // <-- this disables the filter properly
    Filter: DropdownColumnFilter,
  },
  {
    Header: "userId",
    accessor: "userId",
    // width: 250,
    // minWidth: 250,
    // maxWidth: 250,
    type: "text",
    Filter: DropdownColumnFilter,
  },
   {
    Header: "createdDate",
    accessor: "createdDate",
    width: 200,
    minWidth: 200,
    maxWidth: 200,
    type: "text",
    Filter: DropdownColumnFilter,
  },
  {
    Header: "fileCategory",
    accessor: "category",
    // width: 250,
    // minWidth: 250,
    // maxWidth: 250,
    Filter: DropdownColumnFilter,
    type: "text",
  },
  {
    Header: "countOfProcessableRecords",
    accessor: "countOfProcessableRecords",
    // width: 250,
    // minWidth: 250,
    // maxWidth: 250,
    Filter: DropdownColumnFilter,
    type: "text",
  },
  {
    Header: "countOfDeletableRecords",
    accessor: "countOfDeletableRecords",
    // width: 250,
    // minWidth: 250,
    // maxWidth: 250,
    Filter: DropdownColumnFilter,
    type: "text",
  },
  {
    Header: "countOfRateExpirationRecords",
    accessor: "countOfRateExpirationRecords",
    type: "text",
    Filter: DropdownColumnFilter,
  },
   {
    Header: "fileNames",
    accessor: "fileName",
    // width: 250,
    // minWidth: 250,
    // maxWidth: 250,
    Filter: DropdownColumnFilter,
    type: "text",
  },
  {
    Header: "createdAt",
    accessor: "createdAt",
    width: 200,
    minWidth: 200,
    maxWidth: 200,
    type: "text",
    Filter: DropdownColumnFilter,
  },
   {
    Header: "uploadedDate",
    accessor: "uploadedDate",
    width: 200,
    minWidth: 200,
    maxWidth: 200,
    type: "text",
    Filter: DropdownColumnFilter,
  },
  {
    Header: "fileSize",
    accessor: "fileSize",
    width: 100,
    minWidth: 100,
    maxWidth: 100,
    type: "text",
    Filter: DropdownColumnFilter,
  },
  // {
  //   Header: "fileName",
  //   accessor: "fileName",
  //   width: 250,
  //   minWidth: 250,
  //   maxWidth: 250,
  //   type: "text",
  //   Filter: DropdownColumnFilter,
  // },
  {
    Header: "isDownloaded",
    accessor: "isDownloaded",
    width: 100, 
    minWidth: 100,
    maxWidth: 100,
    type: "text",
    Filter: DropdownColumnFilter,
    Cell: ({ value }) => (value === true ? "Y" : value === false ? "N" : "-"),
  },
  {
    Header: "systemRateId",
    accessor: "systemRateId",
    width: 100, 
    minWidth: 100,
    maxWidth: 100,
    type: "text",
    Filter: DropdownColumnFilter,
  }

];

//need to correctly map with correct form of key and value ( not Used)
// export const DEFAULT_COLUMN_VIEW = [
//   { accessor: "carrierScac", header: tableName["carrierScac"] },
//   { accessor: "serviceScac", header: tableName["serviceScac"] },
//   { accessor: "tariffNumber", header: tableName["tariffNumber"] },
//   { accessor: "tariffId", header: tableName["tariffId"] },
//   { accessor: "originZone", header: tableName["originZone"] },
//   { accessor: "originZoneDesc", header: tableName["originZoneDesc"] },
//   { accessor: "originZoneShortDesc", header: tableName["originZoneShortDesc"] },
//   { accessor: "originCountry", header: tableName["originCountry"] },
//   { accessor: "destinationZone", header: tableName["destinationZone"] },
//   { accessor: "destinationZoneDesc", header: tableName["destinationZoneDesc"] },
//   {
//     accessor: "DestinationZoneShortDesc",
//     header: tableName["DestinationZoneShortDesc"],
//   },
//   { accessor: "destinationCountry", header: tableName["destinationCountry"] },
//   { accessor: "equipmentType", header: tableName["equipmentType"] },
//   { accessor: "laneDescription", header: tableName["laneDescription"] },
//   { accessor: "lineHaulChargeType", header: tableName["lineHaulChargeType"] },
//   { accessor: "awardBackup", header: tableName["awardBackup"] },
//   { accessor: "lineHaulRate", header: tableName["lineHaulRate"] },
//   { accessor: "effectiveDate", header: tableName["effectiveDate"] },
//   { accessor: "expirationDate", header: tableName["expirationDate"] },
//   { accessor: "bucketType", header: tableName["bucketType"] },
//   { accessor: "qtyActiveFlag", header: tableName["qtyActiveFlag"] },
//   { accessor: "qtyStartDate", header: tableName["qtyStartDate"] },
//   { accessor: "qtyEndDate", header: tableName["qtyEndDate"] },
//   {
//     accessor: "minShipmentsAllocated",
//     header: tableName["minShipmentsAllocated"],
//   },
//   {
//     accessor: "maxShipmentsAllocated",
//     header: tableName["maxShipmentsAllocated"],
//   },
//   {
//     accessor: "percentageActiveFlag",
//     header: tableName["percentageActiveFlag"],
//   },
//   { accessor: "pctStartDate", header: tableName["pctStartDate"] },
//   { accessor: "pctEndDate", header: tableName["pctEndDate"] },
//   {
//     accessor: "minCarrierAllocationPercentage",
//     header: tableName["minCarrierAllocationPercentage"],
//   },
//   {
//     accessor: "maxCarrierAllocationPercentage",
//     header: tableName["maxCarrierAllocationPercentage"],
//   },
//   { accessor: "modeOfTransport", header: tableName["modeOfTransport"] },
//   { accessor: "status", header: tableName["status"] },
//   { accessor: "bidFileName", header: tableName["bidFileName"] },
//   { accessor: "changeComment", header: tableName["changeComment"] },
//   // { accessor: "message", header: "TM Response" },
//   {
//     accessor: "coupaFileRecordErrors",
//     header: tableName["coupaFileRecordErrors"],
//   }, // No accessor found for this in DRM_COLUMN
// ];

//--------DRMT DEFAULT CUSTOMIZED COLUMN API MOCK-------
// export const DEFAULT_COLUMN_VIEW_API = {
//   user: "",
//   customViews: [
//     {
//       id: 1,
//       bookMarked: false,
//       viewName: "view1",
//       viewCategory: "Bid",
//       columns: [
//         { columnName: "Carrier SCAC", columnNumber: 1 },
//         { columnName: "Service SCAC", columnNumber: 2 },
//         { columnName: "Tariff Number", columnNumber: 3 },
//         { columnName: "Tariff ID", columnNumber: 4 },
//         //user define column are not added pls consider
//         { columnName: "Origin Zone", columnNumber: 5 },
//         { columnName: "Origin Zone Desc", columnNumber: 6 },
//         { columnName: "Origin Zone Short Desc", columnNumber: 7 },
//         { columnName: "Origin Country", columnNumber: 8 },
//         { columnName: "Destination Zone", columnNumber: 9 },
//         { columnName: "Destination Zone Desc", columnNumber: 10 },
//         { columnName: "Destination Zone Short Desc", columnNumber: 11 },
//         { columnName: "Destination Country", columnNumber: 12 },
//         { columnName: "Equip Type", columnNumber: 13 },
//         { columnName: "Lane Description", columnNumber: 14 },
//         { columnName: "Charge ID", columnNumber: 15 },
//         { columnName: "Rate", columnNumber: 16 },
//         { columnName: "Award/Backup", columnNumber: 17 },
//         { columnName: "Effective Date", columnNumber: 18 },
//         { columnName: "Expiration Date", columnNumber: 19 },
//         { columnName: "Bucket Type", columnNumber: 20 },
//         { columnName: "Qty Active Flag", columnNumber: 21 },
//         { columnName: "Qty Start Date", columnNumber: 22 },
//         { columnName: "Qty End Date", columnNumber: 23 },
//         { columnName: "Min Qty Award", columnNumber: 24 },
//         { columnName: "Max Qty Award", columnNumber: 25 },
//         { columnName: "Pct Active Flag", columnNumber: 26 },
//         { columnName: "Pct Start Date", columnNumber: 27 },
//         { columnName: "Pct End Date", columnNumber: 28 },
//         { columnName: "Min Pct Award", columnNumber: 29 },
//         { columnName: "Pct Award", columnNumber: 30 },
//         { columnName: "Mode of Transport", columnNumber: 31 },
//         { columnName: "Status", columnNumber: 32 },
//         { columnName: "Bid File Name", columnNumber: 33 },
//         { columnName: "Change Comments", columnNumber: 34 },
//         { columnName: "Errors", columnNumber: 35 },
//       ],
//     },
//     {
//       id: 2,
//       bookMarked: true,
//       viewName: "view2",
//       viewCategory: "Bid",
//       columns: [
//         { columnName: "Status", columnNumber: 1 },
//         { columnName: "Carrier SCAC", columnNumber: 2 },
//         { columnName: "Lane Description", columnNumber: 3 },
//         { columnName: "Origin Country", columnNumber: 4 },
//         { columnName: "Destination Country", columnNumber: 5 },
//         { columnName: "Rate", columnNumber: 6 },
//         { columnName: "Equip Type", columnNumber: 7 },
//         { columnName: "Service SCAC", columnNumber: 8 },
//         { columnName: "Tariff Number", columnNumber: 9 },
//         { columnName: "Tariff ID", columnNumber: 10 },
//         { columnName: "Origin Zone", columnNumber: 11 },
//         { columnName: "Origin Zone Desc", columnNumber: 12 },
//         { columnName: "Origin Zone Short Desc", columnNumber: 13 },
//         { columnName: "Destination Zone", columnNumber: 14 },
//         { columnName: "Destination Zone Desc", columnNumber: 15 },
//         { columnName: "Destination Zone Short Desc", columnNumber: 16 },
//         { columnName: "Charge ID", columnNumber: 17 },
//         { columnName: "Award/Backup", columnNumber: 18 },
//         { columnName: "Effective Date", columnNumber: 19 },
//         { columnName: "Expiration Date", columnNumber: 20 },
//         { columnName: "Bucket Type", columnNumber: 21 },
//         { columnName: "Qty Active Flag", columnNumber: 22 },
//         { columnName: "Qty Start Date", columnNumber: 23 },
//         { columnName: "Qty End Date", columnNumber: 24 },
//         { columnName: "Min Qty Award", columnNumber: 25 },
//         { columnName: "Max Qty award", columnNumber: 26 },
//         { columnName: "Pct Active Flag", columnNumber: 27 },
//         { columnName: "Pct Start Date", columnNumber: 28 },
//         { columnName: "Pct End Date", columnNumber: 29 },
//         { columnName: "Min Pct Award", columnNumber: 30 },
//         { columnName: "Pct Award", columnNumber: 31 },
//         { columnName: "Mode of Transport", columnNumber: 32 },
//         { columnName: "Bid File Name", columnNumber: 33 },
//         { columnName: "Change Comments", columnNumber: 34 },
//         { columnName: "Errors", columnNumber: 35 },
//       ],
//     },
//   ],
// };
